import React, { useContext, useState } from "react";

import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";
import Markdown from "../../styles/Markdown";
import VideoGallery from "./VideoGallery";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  ${(props) => props.dynamicStyles || ""}

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const TabsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 10px;

  @media (min-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    flex-wrap: nowrap; /* Prevent wrapping on desktop */
  }
`;

const Tab = styled.div`
  flex: 1;
  text-align: center;
  color: ${(props) => (props.active ? "white" : "black")};
  cursor: pointer;

  @media (min-width: 768px) {
    text-align: left;
    flex: none;
  }
`;

const ContentArea = styled.div`
  flex-grow: 1;
  padding: 20px;
`;

function TabSystem() {
  const [activeTab, setActiveTab] = useState(0);
  const { videoGalleryTabs, CSS, wrapperClassName, uniqueId } =
    useContext(ComponentContext);

  return (
    <Container dynamicStyles={CSS} className={wrapperClassName} id={uniqueId}>
      <TabsContainer className="tabs-container">
        {videoGalleryTabs.map((item, index) => (
          <Tab
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            active={activeTab === index}
            onClick={() => setActiveTab(index)}
            className={activeTab === index ? "active-tab" : "inactive-tab"}
          >
            <Markdown className="h-100">{item.header}</Markdown>
          </Tab>
        ))}
      </TabsContainer>
      <ContentArea className="tab-content">
        {videoGalleryTabs[activeTab] && (
          <div>
            <Markdown className="tab-markdown">
              {videoGalleryTabs[activeTab].text}
            </Markdown>
            <VideoGallery
              items={videoGalleryTabs[activeTab].videoGalleryItems}
              activeTab={activeTab}
            />
          </div>
        )}
      </ContentArea>
    </Container>
  );
}

export default TabSystem;
